import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GrowAGardenAbout.css';

const GrowAGardenAbout = () => {
  const navigate = useNavigate();

  return (
    <div className="grow-a-garden-about">
      <h2>About Roblox Grow a Garden + Free Fruit Value Calculator</h2>
      
      <p>
        <strong>Grow a Garden</strong> is a farming simulation game on Roblox where players plant, grow, mutate, and sell a wide variety of fruits and crops. From basic fruits to rare hybrids, the game features a relaxing yet strategic gardening experience full of upgrades, trading, and seasonal surprises.
      </p>

      <p>
        Players begin with a small patch of soil and gradually expand their garden by harvesting fruits, unlocking new seeds, mutating crops, and completing in-game tasks. The game also includes pets, weather effects, and cosmetic decorations to personalize your farm.
      </p>

      <ul>
        <li>🌱 Grow over <strong>50+ types of fruits and crops</strong>, including rare and tropical varieties</li>
        <li>🔁 Discover fruit mutations to boost value and rarity</li>
        <li>🎒 Complete daily quests and earn Seed Packs</li>
        <li>🐾 Unlock and level up pets to increase farming efficiency</li>
        <li>🛒 Trade seeds, fruits, and tools with other players</li>
        <li>🎉 Join seasonal events with limited-time content</li>
      </ul>

      <h3>Free Roblox Grow a Garden Fruit Calculator</h3>
      <p>
        Our site includes a handy <strong>Fruit Value Calculator</strong> built specifically for Grow a Garden players. Use it to:
      </p>
      <ul>
        <li>💰 Calculate total fruit value using weight and mutation bonuses</li>
        <li>🧬 Plan which mutations are most profitable</li>
        <li>📊 Optimize your harvest before selling to maximize income</li>
      </ul>

      <div style={{ display: 'flex', gap: '1em', flexWrap: 'wrap', marginTop: '1em' }}>
        <button
          className="go-to-calculator-btn"
          onClick={() => {
            window.scrollTo(0, 0);
            navigate('/fruits-calculator');
          }}
          style={{
            padding: '0.7em 1.5em',
            background: '#a3d977',
            color: '#29522e',
            border: 'none',
            borderRadius: '8px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Go to Fruit Calculator
        </button>

        <button
          className="go-to-pet-guides-btn"
          onClick={() => {
            window.scrollTo(0, 0);
            navigate('/Pets');
          }}
          style={{
            padding: '0.7em 1.5em',
            background: '#f7c66c',
            color: '#5c3b00',
            border: 'none',
            borderRadius: '8px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          View Pet Guides
        </button>

        <button
          className="go-to-fruit-giveaway-btn"
          onClick={() => {
            window.scrollTo(0, 0);
            navigate('/fruit-giveaway');
          }}
          style={{
            padding: '0.7em 1.5em',
            background: '#ffb347',
            color: '#7a3e00',
            border: 'none',
            borderRadius: '8px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Go to Fruit Giveaway
        </button>
      </div>

      <p style={{ marginTop: '1.5em' }}>
        Whether you're a casual gardener or a mutation-hunting expert, our Grow a Garden tools and guides are here to help you play smarter and earn more!
      </p>
    </div>
  );
};

export default GrowAGardenAbout;
